import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const transferApi = createAsyncThunk("transfer", async () => {
  const response = await axiosInstance.get("/transfer");
  return response.data;
});

const transferSlice = createSlice({
  name: "transfer",
  initialState: {
    transfer: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(transferApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(transferApi.fulfilled, (state, action) => {
        state.transfer = action.payload;
        state.loading = false;
      })
      .addCase(transferApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default transferSlice.reducer;
